import { createFileRoute, Navigate } from "@tanstack/react-router";
import { IntegrationsPage } from "@/pages/integrations";
import { useIsOwnerOrAdmin } from "@/entities/user/hooks/use-is-owner-or-admin";
import { useFeatureAccess } from "@/entities/company/hooks/use-feature-access";

const IntegrationsRoute = () => {
  const { isOwnerOrAdmin } = useIsOwnerOrAdmin();
  const canUseFeature = useFeatureAccess();

  if (!isOwnerOrAdmin || !canUseFeature("integrations")) {
    return <Navigate to="/" replace />;
  }

  return <IntegrationsPage />;
};

export const Route = createFileRoute(
  "/_authed/$companySlug/_settings/settings/integrations",
)({
  component: IntegrationsRoute,
});
